import React, { useRef, Suspense } from "react";
import SiteNav from "../components/common/SiteNav";
import ScrollProgress from "../components/common/ScrollProgress";
import AmbientLayer from "../components/common/AmbientLayer";
import PageSuspenseFallback from "../components/layout/PageSuspenseFallback";

const LandingPage = React.lazy(() => import("../pages/LandingPage"));
const AboutMePage = React.lazy(() => import("../pages/AboutMePage"));
const ProjectsPage = React.lazy(() => import("../pages/ProjectsPage"));
const ContactPage = React.lazy(() => import("../pages/ContactPage"));

export default function MainLayout() {
  const contactPageRef = useRef(null);
  const projectsPageRef = useRef(null);

  return (
    <div id="layoutContainer">
      <AmbientLayer />
      <div className="layout-surface">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <ScrollProgress />
        <SiteNav />
        <main id="main-content" tabIndex={-1}>
          <Suspense fallback={<PageSuspenseFallback />}>
            <LandingPage
              contactPageRef={contactPageRef}
              projectsPageRef={projectsPageRef}
            />
            <AboutMePage />
            <div ref={projectsPageRef} id="projects">
              <ProjectsPage />
            </div>
            <div ref={contactPageRef} id="ContactPage">
              <ContactPage />
            </div>
          </Suspense>
        </main>
      </div>
    </div>
  );
}
